// extracted by mini-css-extract-plugin
module.exports = {"container":"ResetPassword_container__2o5R9","formContainer":"ResetPassword_formContainer__K6V5q"};